// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as AuthTokenHook$LiveRoom from "../../stores/AuthTokenHook.bs.js";
import * as SterlingModal$LiveRoom from "../../bindings/SterlingModal.bs.js";
import * as Button from "@sothebys/sterling/button";
import * as SterlingTypography$LiveRoom from "../../bindings/SterlingTypography.bs.js";

function LoginModal(props) {
  var onClose = props.onClose;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  return React.createElement(SterlingModal$LiveRoom.Modal.make, {
              children: null,
              className: Curry._1(Css.style, {
                    hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                          hd: Css.minWidth(Css.px(468)),
                          tl: /* [] */0
                        }),
                    tl: {
                      hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                            hd: Css.minWidth(Css.px(200)),
                            tl: /* [] */0
                          }),
                      tl: /* [] */0
                    }
                  }),
              onClose: onClose,
              isOpen: true,
              headerTitle: Curry._1(t, "Common_pleaseLogIn"),
              closeOnOutsideClick: true
            }, React.createElement(SterlingModal$LiveRoom.Content.make, {
                  children: React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                        children: Curry._1(t, "LoginModal_conditionReport")
                      })
                }), React.createElement(SterlingModal$LiveRoom.Footer.make, {
                  children: null,
                  className: Curry._1(Css.style, {
                        hd: Css.display("flex"),
                        tl: {
                          hd: Css.justifyContent("center"),
                          tl: {
                            hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                                  hd: Css.display("block"),
                                  tl: /* [] */0
                                }),
                            tl: /* [] */0
                          }
                        }
                      })
                }, React.createElement(Button.Button, {
                      onClick: (function (param) {
                          AuthTokenHook$LiveRoom.triggerLogin(window.location.href);
                        }),
                      children: Curry._1(t, "LoginModal_logIn")
                    }), React.createElement(Button.Button, {
                      onClick: (function (param) {
                          AuthTokenHook$LiveRoom.triggerRegister(window.location.href);
                        }),
                      className: Curry._1(Css.style, {
                            hd: Css.margin2("zero", Css.px(16)),
                            tl: {
                              hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                                    hd: Css.margin2(Css.px(8), "zero"),
                                    tl: /* [] */0
                                  }),
                              tl: /* [] */0
                            }
                          }),
                      children: Curry._1(t, "LoginModal_signUp")
                    }), React.createElement(Button.Button, {
                      onClick: (function (param) {
                          Curry._1(onClose, undefined);
                        }),
                      buttonStyle: "secondary",
                      children: Curry._1(t, "LoginModal_notNow")
                    })));
}

var make = LoginModal;

export {
  make ,
}
/* Css Not a pure module */
